import type { HelpFile } from '../../types/help'
import { LdapProvisioningConfigEditorTestIds } from '../../../testids/LdapProvisioningConfigEditorTestIds'

export const ldapProvisioningConfigEditorHelp: HelpFile = {
  docPage: '/docs/systems/connectors',
  texts: {
    [LdapProvisioningConfigEditorTestIds.ldapProvisioningConfigCard]:
      'LDAP-Bereitstellungskonfiguration — legt fest, wo Konten im Verzeichnis platziert werden, welche Objektklassen zugewiesen werden und wie Distinguished Names aufgebaut werden.',
    [LdapProvisioningConfigEditorTestIds.cardTitleLdapProvisioningConfig]:
      'LDAP-Bereitstellungseinstellungen — Objektklassen, DN-Vorlage, Standard-OU und OU-Routing-Regeln.',
    [LdapProvisioningConfigEditorTestIds.objectClasses]:
      'LDAP-Objektklassen, die jedem von diesem Konnektor erstellten Konto zugewiesen werden — typische Werte: top, person, organizationalPerson, user (Active Directory) oder inetOrgPerson (OpenLDAP).',
    [LdapProvisioningConfigEditorTestIds.ldapDnTemplate]:
      'Vorlage zum Aufbau des Distinguished Name jedes bereitgestellten Kontos — muss den Platzhalter {ou} enthalten. Beispiel: cn={cn},{ou}.',
    [LdapProvisioningConfigEditorTestIds.ldapDefaultOu]:
      'Fallback-Organisationseinheit, wenn keine OU-Routing-Regel zutrifft — auch die einzige OU, wenn keine Regeln definiert sind. Beispiel: ou=Users,dc=example,dc=com.',
    [LdapProvisioningConfigEditorTestIds.ouRulesTable]:
      'OU-Routing-Regeln bestimmen, welche Organisationseinheit ein bereitgestelltes Konto erhält — der Reihe nach ausgewertet, erste passende Regel greift, Standard-OU als Fallback.',
    [LdapProvisioningConfigEditorTestIds.ouRulesReadonlyTable]:
      'Schreibgeschützte Ansicht der aktuell gültigen OU-Routing-Regeln.',
    [LdapProvisioningConfigEditorTestIds.ldapProvisioningConfigLoading]:
      'Die LDAP-Bereitstellungskonfiguration wird noch vom Server geladen — das Formular erscheint, sobald die Anfrage abgeschlossen ist.',
    [LdapProvisioningConfigEditorTestIds.colOuAttribute]:
      'Konto-Attribut, das die Routing-Regel auswertet, z. B. Abteilung oder Standort.',
    [LdapProvisioningConfigEditorTestIds.colOuOperator]:
      'Vergleichsoperator für den Attributwert (gleich, in, beginnt mit, …).',
    [LdapProvisioningConfigEditorTestIds.colOuValue]:
      'Wert(e), die das Attribut erfüllen muss, damit diese Routing-Regel greift.',
    [LdapProvisioningConfigEditorTestIds.colOuTarget]:
      'Ziel-DN der Organisationseinheit, in der passende Konten platziert werden.',
    [LdapProvisioningConfigEditorTestIds.colOuActions]:
      'Aktionen pro Zeile für die Routing-Regel.',
    [LdapProvisioningConfigEditorTestIds.colOuAttributeReadonly]: null,
    [LdapProvisioningConfigEditorTestIds.colOuOperatorReadonly]: null,
    [LdapProvisioningConfigEditorTestIds.colOuValueReadonly]: null,
    [LdapProvisioningConfigEditorTestIds.colOuTargetReadonly]: null,
    [LdapProvisioningConfigEditorTestIds.btnAddOuRule]:
      'Neue OU-Routing-Regel am Ende der Liste hinzufügen.',
    [LdapProvisioningConfigEditorTestIds.btnLdapSave]: null,
    [LdapProvisioningConfigEditorTestIds.btnLdapCancel]: null,
    [LdapProvisioningConfigEditorTestIds.ldapDirtyActions]:
      'Speichern- und Abbrechen-Aktionen — erscheinen bei ungespeicherten Änderungen.',
    [LdapProvisioningConfigEditorTestIds.defaultOuError]:
      'Validierungsfehler: Standard-OU fehlt oder ist fehlerhaft.',
    [LdapProvisioningConfigEditorTestIds.dnTemplateError]:
      'Validierungsfehler: DN-Vorlage fehlt oder enthält den erforderlichen Platzhalter {ou} nicht.',
  },
}
